'use client';

import { toReadableAddress } from '@/lib/utils';
import { ApartmentConfig, type MarketApartment } from '@pigello/pigello-matrix';
import type { RelationFieldProps } from './types';
import { StatusBadge } from '@/components/ui/statusBadge';
import { cn } from '@/lib/cn';
import Dot from './dot';

export const MarketApartmentItem: RelationFieldProps<MarketApartment> = {
  nested: ['space'],
  filters: [],
  renderItem: (item, isRelationField) => ({
    title:
      item.space?.landlordCustomId ?? item.space?.apartmentId ?? item.customId,
    badge:
      item.space?.status != null ? (
        <StatusBadge className='font-medium' status={item.space?.status} />
      ) : undefined,
    descriptionItems: (
      <div
        className={cn(
          isRelationField ? 'grid w-full' : 'flex flex-row items-center'
        )}
      >
        <div className='font-medium'>
          {item.space?.address
            ? toReadableAddress(item.space?.address, true, false)
            : 'Ingen adress angiven'}
        </div>
        {!isRelationField && <Dot />}
        <div
          className={cn(
            'flex w-full items-center',
            isRelationField && 'justify-between'
          )}
        >
          <span>
            {ApartmentConfig.fields.category.choices?.find(
              (c) => c.v === item.space?.category
            )?.d ?? 'Ingen kategori angiven'}
          </span>
          {!isRelationField && <Dot />}
          <span>
            {item.space?.landlordCustomId ??
              item.customId ??
              'Inget objekts-id angivet'}
          </span>
        </div>
      </div>
    ),
  }),
};
